import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hotel-bookings-badge',
  templateUrl: './hotel-bookings-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotelBookingsBadgeComponent {}
